/* eslint-disable max-lines */
import { isAvailable } from './availability';
import { terms } from './constructors';
import { getTermsValue } from './helpers';
import { ERoomType, FDealType, FOfferType, IJsonQuery, TJsonQueryKeys } from './types';
import { offerTypeFromJsonQuery } from './utils';

interface IPropertyConfig {
  availability?(jsonQuery: IJsonQuery): boolean;
  converter?(jsonQuery: IJsonQuery): IJsonQuery;
}

export const PROPERTIES: { [key in Required<TJsonQueryKeys>]: IPropertyConfig } = {
  _type: {},
  engine_version: {},
  for_day: { availability: isAvailable(FDealType.Rent, FOfferType.Residential) },
  geo: {},
  room: {
    converter: jsonQuery => {
      const nextOfferType = offerTypeFromJsonQuery(jsonQuery);
      const room = getTermsValue('room')(jsonQuery);

      if (!room || (nextOfferType & FOfferType.Flat) !== 0) {
        return jsonQuery;
      }

      const nextRoom = room.filter(
        t =>
          ![
            ERoomType.FlatOneRoom,
            ERoomType.FlatTwoRooms,
            ERoomType.FlatThreeRooms,
            ERoomType.FlatFourRooms,
            ERoomType.FlatFiveRooms,
            ERoomType.FlatManyRooms,
            ERoomType.FlatFreeLayout,
            ERoomType.Studio,
          ].includes(t),
      );

      return {
        ...jsonQuery,
        room: terms(nextRoom),
      };
    },
  },
};
